<template>
	<!-- <div>
		<div class="row mb-3">
			<div class="col-lg-4">
				<label>N° de Estimación</label>
				<input type="text" v-model="ProyectoAdicion.NumEstimacion" class="form-control" placeholder="N° de Estimación"/>
			</div>
			<div class="col-lg-4">
				<label>Fecha</label>
				<v-date-picker v-model="ProyectoAdicion.Fecha" :mode="typeCalendar"
					:popover="{
						placement: 'bottom',
						visibility: 'click'
					}"
					:input-props="{
						class: 'form-control cal-black',
						style: 'cursor:pointer;'
					}"
                    :locale="'es-MX'"
				/>
			</div>
			<div class="col-lg-4">
				<label>Motivo</label>
				<select v-model="ProyectoAdicion.Motivo" class="form-control">
					<option value="">-Motivo-</option>
					<option value="1">Modificación Proyecto</option>
					<option value="2">Trabajo Extra</option>
					<option value="3">Cambio Especificación</option>
					<option value="4">Ampliación Término</option>
					<option value="5">Horas Extras</option>
					<option value="6">Reposición de Material</option>
					<option value="7">Otros</option>
				</select>
			</div>
		</div>
		<div class="row mb-3">
			<div class="col-lg-12">
				<label>Descripción</label>
				<textarea v-model="ProyectoAdicion.Descripcion" class="form-control" cols="30" rows="4" placeholder="Descripción"></textarea>
			</div>
		</div>
		<div class="row mb-3">
			<div class="col-lg-4">
				<label>Venta</label>
				<vue-numeric
					class="form-control "
					currency="$"
					separator=","
					placeholder="$0"
					:precision="0"
					v-model="ProyectoAdicion.Venta"
				></vue-numeric>
			</div>
			<div class="col-lg-4">
				<label>Costo Operacional</label>
				<vue-numeric
					class="form-control "
					currency="$"
					separator=","
					placeholder="$0"
					:precision="0"
					v-model="ProyectoAdicion.CostoOperacional"
				></vue-numeric>
			</div>
			<div class="col-lg-4">
				<label>Gross Profit</label>
				<vue-numeric
					class="form-control "
					currency=""
					separator=","
					placeholder="0%"
					:precision="0"
					v-model="ProyectoAdicion.GrossProfit"
				></vue-numeric>
			</div>
		</div>
		<div class="row mb-3">
			<div class="col-lg-3">
				<label>Aprobación</label>
				<select v-model="ProyectoAdicion.Aprobacion" class="form-control">
					<option value="">-Aprobación-</option>
					<option value="1">Pendiente</option>
					<option value="2">Aprobada</option>
					<option value="3">No Aprobada</option>
				</select>
			</div>
			<div class="col-lg-3">
				<label>Fecha Aprobación</label>
				<v-date-picker v-model="ProyectoAdicion.FechaAprobacion" :mode="typeCalendar"
					:popover="{
						placement: 'bottom',
						visibility: 'click'
					}"
					:input-props="{
						class: 'form-control cal-black',
						style: 'cursor:pointer;'
					}"
                    :locale="'es-MX'"
				/>
			</div>
			<div class="col-lg-3">
				<label>Estatus</label>
				<select v-model="ProyectoAdicion.Estatus" class="form-control">
					<option value="">-Estatus-</option>
					<option value="1">No Aprobada</option>
					<option value="2">En Proceso</option>
					<option value="3">Terminada</option>
				</select>
			</div>
			<div class="col-lg-3">
				<label>Fecha Estatus</label>
				<v-date-picker v-model="ProyectoAdicion.FechaEstatus" :mode="typeCalendar"
					:popover="{
						placement: 'bottom',
						visibility: 'click'
					}"
					:input-props="{
						class: 'form-control cal-black',
						style: 'cursor:pointer;'
					}"
                    :locale="'es-MX'"
				/>
			</div>
		</div>
		<div class="row">
			<div class="col-lg-6">
				<label>Evidencia 1</label>
				<div class="custom-file-input-image">
					<input @change="SubirArchivo1()" type="file" accept="application/pdf" ref="archivouno" class="custom-file-input" id="validatedCustomFile" required>
					<input type="text" v-model="ArchivoUno" class="form-control">
					<button type="button" class=""><i class="fas fa-paperclip"></i></button>
				</div>
			</div>
			<div class="col-lg-6">
				<label>Evidencia 2</label>
				<div class="custom-file-input-image">
					<input @change="SubirArchivo2()" type="file" accept="application/pdf" ref="archivodos" class="custom-file-input" id="validatedCustomFile" required>
					<input type="text" v-model="ArchivoDos" class="form-control">
					<button type="button" class=""><i class="fas fa-paperclip"></i></button>
				</div>
			</div>
		</div>
	</div> -->
	<div>
		<div class="row">
			<!-- <div class="col-lg-3">
				<label>N° de Contrato *</label>
				<select v-model="ProyectoAdicion.IdContrato" class="form-control" @change="SeleccionContrato()">
					<option value="">-Contrato-</option>
					<option v-for="(item,index) in ListContratos" :value="item.IdContrato" :key="index">{{item.NumeroC}}</option>
				</select>
				<Cvalidation v-if="this.errorvalidacion.IdContrato" :Mensaje="errorvalidacion.IdContrato[0]"></Cvalidation>
			</div>
			<div class="col-lg-3">
				<label>Propuesta</label>
				<input type="text" class="form-control" v-model="ProyectoAdicion.Propuesta" disabled>
			</div> -->
			<div class="col-lg-3">
				<label>N° de Propuesta *</label>
				<select v-model="ProyectoAdicion.IdPropuesta" class="form-control" @change="SeleccionPropuesta()">
					<option value="">-Propuesta-</option>
					<option v-for="(item,index) in ListPropuestas" :value="item.IdPropuesta" :key="index">{{item.Numero}}</option>
				</select>
				<Cvalidation v-if="this.errorvalidacion.IdPropuesta" :Mensaje="errorvalidacion.IdPropuesta[0]"></Cvalidation>
			</div>
			<div class="col-lg-3">
				<label>Tipo de Contrato</label>
				<input type="text" class="form-control" v-model="ProyectoAdicion.TipoContrato" disabled>
			</div>
			<div class="col-lg-3">
				<label>Tipo de Servicio</label>
				<input type="text" class="form-control" v-model="ProyectoAdicion.IdConfigS" disabled>
			</div>
		</div>
		<div class="row mt-3">
			<div class="col-lg-3">
				<label>SubTipo de Servicio</label>
				<input type="text" class="form-control" v-model="ProyectoAdicion.IdTipoSer" disabled>
			</div>
			<div class="col-lg-2">
				<label>Valor Venta</label>
				<vue-numeric
					disabled
					class="form-control"
					currency="$"
					separator=","
					placeholder="$0"
					:precision="0"
					v-model="ProyectoAdicion.ValorVenta"
				></vue-numeric>
			</div>
			<div class="col-lg-2">
				<label>Cantidad de Pagos</label>
				<input type="text" class="form-control" v-model="ProyectoAdicion.CantidadPago" disabled>
			</div>
			<div class="col-lg-2">
				<label>Fecha de Venta</label>
				<v-date-picker v-model="ProyectoAdicion.FechaVenta" :mode="typeCalendar"
					:popover="{
						placement: 'bottom',
						visibility: 'click'
					}"
					:input-props="{
						class: 'form-control cal-black',
						style: 'cursor:pointer;'
					}"
                    :locale="'es-MX'"
					>
						<template v-slot="{ inputValue, inputEvents }">
							<input type="text" disabled="true" :value="inputValue" class="form-control calendar" style="cursor:pointer;background-color:#F9F9F9"
                        	v-on="inputEvents">
						</template>
				</v-date-picker>
			</div>
			<div class="col-lg-2">
				<label>Fecha de Termino</label>
				<v-date-picker v-model="ProyectoAdicion.FechaTermino" :mode="typeCalendar"
					:popover="{
						placement: 'bottom',
						visibility: 'click'
					}"
					:input-props="{
						class: 'form-control cal-black',
						style: 'cursor:pointer;'
					}"
                    :locale="'es-MX'"
					>
						<template v-slot="{ inputValue, inputEvents }">
							<input type="text" disabled="true" :value="inputValue" class="form-control calendar" style="cursor:pointer;background-color:#F9F9F9"
                        	v-on="inputEvents">
						</template>
				</v-date-picker>
			</div>
		</div>
		<div class="row mt-3">
			<div class="col-lg-4">
				<label>Vendedor</label>
				<input type="text" class="form-control" v-model="ProyectoAdicion.Vendedor" disabled>
			</div>
		</div>
	</div>
</template>

<script>
import Cvalidation from '@/components/Cvalidation.vue'
export default {
	name:"Adicion",
    props:["poBtnSave","pIdProyecto","pIdContratoMaster","pIdCliente","pIdClienteS"],
	components:{Cvalidation},
	data() {
		return {
			Modal:true,
            FormName:'Adicion',
            EmitSeccion:this.poBtnSave.EmitSeccion,
			ProyectoAdicion:{
				IdProyectoAdicion:0,
				IdProyecto:0,
				IdVenta:'',
				IdPropuesta:'',
				// IdContrato:'',
				FechaVenta:'',
				FechaTermino:'',
				IdConfigS:'',
				IdTipoSer:'',
				TipoContrato:'',
				ValorVenta:0,
				CantidadPago:'',
				Vendedor:'',
				Propuesta:''
			},
			IdContratoMaster:'',
			ArchivoUno:'Elegir Archivo (1MB)',
			ArchivoDos:'Elegir Archivo (1MB)',
			errorvalidacion:[],
			ListContratos:[],
			ListPropuestas:[],
			ListPropuestasOcupadas:[]
		}
	},
	methods: {
		Guardar(){
			// let Fecha='';
			// let FechaAprobacion='';
			// let FechaEstatus='';
			// if (this.ProyectoAdicion.Fecha!='' && this.ProyectoAdicion.Fecha!=undefined) {
            //     let day=this.ProyectoAdicion.Fecha.getDate();
            //     let month=this.ProyectoAdicion.Fecha.getMonth()+1;
            //     let year=this.ProyectoAdicion.Fecha.getFullYear();
            //     Fecha=year+'-'+month+'-'+day;   
            // }
			// if (this.ProyectoAdicion.FechaAprobacion!='' && this.ProyectoAdicion.FechaAprobacion!=undefined) {
            //     let day=this.ProyectoAdicion.FechaAprobacion.getDate();
            //     let month=this.ProyectoAdicion.FechaAprobacion.getMonth()+1;
            //     let year=this.ProyectoAdicion.FechaAprobacion.getFullYear();
            //     FechaAprobacion=year+'-'+month+'-'+day;   
            // }
			// if (this.ProyectoAdicion.FechaEstatus!='' && this.ProyectoAdicion.FechaEstatus!=undefined) {
            //     let day=this.ProyectoAdicion.FechaEstatus.getDate();
            //     let month=this.ProyectoAdicion.FechaEstatus.getMonth()+1;
            //     let year=this.ProyectoAdicion.FechaEstatus.getFullYear();
            //     FechaEstatus=year+'-'+month+'-'+day;   
            // }
			let formData=new FormData();
			formData.set('IdProyectoAdicion',this.ProyectoAdicion.IdProyectoAdicion);
			formData.set('IdProyecto',this.ProyectoAdicion.IdProyecto);
			formData.set('IdVenta',this.ProyectoAdicion.IdVenta);
			formData.set('IdPropuesta',this.ProyectoAdicion.IdPropuesta);
			// formData.set('IdContrato',this.ProyectoAdicion.IdContrato);
			// formData.set('Fecha',Fecha);
			// formData.set('Motivo',this.ProyectoAdicion.Motivo);
			// formData.set('Descripcion',this.ProyectoAdicion.Descripcion);
			// formData.set('Venta',this.ProyectoAdicion.Venta);
			// formData.set('CostoOperacional',this.ProyectoAdicion.CostoOperacional);
			// formData.set('GrossProfit',this.ProyectoAdicion.GrossProfit);
			// formData.set('Aprobacion',this.ProyectoAdicion.Aprobacion);
			// formData.set('FechaAprobacion',FechaAprobacion);
			// formData.set('Estatus',this.ProyectoAdicion.Estatus);
			// formData.set('FechaEstatus',FechaEstatus);
			// formData.set('ArchivoUno',this.ProyectoAdicion.ArchivoUno);
			// formData.set('ArchivoDos',this.ProyectoAdicion.ArchivoDos);
			// let image=this.$refs.archivouno.files[0];
			// formData.append('ArchivoUnoFile',image);
			// let image2=this.$refs.archivodos.files[0];
			// formData.append('ArchivoDosFile',image2);
			this.poBtnSave.toast=0;
            this.poBtnSave.disableBtn=true;
			this.$http.post('proyectoadicion/post',formData,{
				headers:{
                    'Content-Type':'multipart/form-data'
                }
			}).then((res)=>{
				this.poBtnSave.disableBtn=false; 
                this.poBtnSave.toast=1;
                $("#Adicion").modal("hide");
				this.bus.$emit('List');
                this.bus.$emit('ListaPrincipal');
			}).catch((err)=>{
                this.errorvalidacion=err.response.data.message.errores;
                this.poBtnSave.disableBtn=false;
                this.poBtnSave.toast=2;
            });
		},
		Limpiar(){
			this.ProyectoAdicion={
				IdProyectoAdicion:0,
				IdProyecto:0,
				IdVenta:'',
				IdPropuesta:'',
				// IdContrato:'',
				FechaVenta:'',
				FechaTermino:'',
				IdConfigS:'',
				IdTipoSer:'',
				TipoContrato:'',
				ValorVenta:0,
				CantidadPago:'',
				Vendedor:'',
				Propuesta:''
			};
			this.errorvalidacion=[];
			this.ArchivoUno='Elegir Archivo (1MB)';
			this.ArchivoDos='Elegir Archivo (1MB)';
			this.ListPropuestasOcupadas=[];
		},
		Recuperar(){
			this.$http.get('proyectoadicion/recovery',{
                params:{
                    IdProyectoAdicion:this.ProyectoAdicion.IdProyectoAdicion
                }
            }).then((res)=>{
				const objres=res.data.data.proyectoadicion;
				this.ProyectoAdicion.IdProyectoAdicion=objres.IdProyectoAdicion;
				this.ProyectoAdicion.IdProyecto=objres.IdProyecto;
				this.ProyectoAdicion.IdVenta=objres.IdVenta;
				// this.ProyectoAdicion.IdContrato=objres.IdContrato;
				this.ProyectoAdicion.IdPropuesta=objres.IdPropuesta;
				// this.GetContratos();
				this.GetPropuestas();
				// this.ProyectoAdicion.Venta=objres.Venta;
				// this.ProyectoAdicion.CostoOperacional=objres.CostoOperacional;
				// this.ProyectoAdicion.GrossProfit=objres.GrossProfit;
				// this.ProyectoAdicion.Aprobacion=objres.Aprobacion;
				// this.ProyectoAdicion.Estatus=objres.Estatus;
				// this.ProyectoAdicion.ArchivoUno=objres.ArchivoUno;
				// this.ProyectoAdicion.ArchivoDos=objres.ArchivoDos;
				// let formatedDate = objres.Fecha.replace(/-/g, "\/");
				// this.ProyectoAdicion.Fecha=new Date(formatedDate);
				// let formatedDate2 = objres.FechaAprobacion.replace(/-/g, "\/");
				// this.ProyectoAdicion.FechaAprobacion=new Date(formatedDate2);
				// let formatedDate3 = objres.FechaEstatus.replace(/-/g, "\/");
				// this.ProyectoAdicion.FechaEstatus=new Date(formatedDate3);
				// this.ArchivoUno=objres.ArchivoUno;
				// this.ArchivoDos=objres.ArchivoDos;
			});
		},
		GetContratos(){
			this.$http.get('ventas/get',{
				params:{
					IdContratoMaster:this.pIdContratoMaster
				}
			}).then((res)=>{
				this.ListContratos=res.data.data.todos;
				if (this.ProyectoAdicion.IdProyectoAdicion>0) {
					this.SeleccionContrato();
				}
			})
		},
		GetPropuestas(){
			this.$http.get('propuestasventa/get',{
				params:{
					IdCliente:this.pIdCliente,
					IdClienteS:this.pIdClienteS
				}
			}).then((res)=>{
				this.ListPropuestas=res.data.data.propuestas;
				this.ListPropuestasOcupadas=res.data.data.ocupados;
				if (this.ProyectoAdicion.IdProyectoAdicion>0) {
					this.SeleccionPropuesta();
				}
				this.FiltroListaPropuesta();
			})
		},
		FiltroListaPropuesta(){
			let ListaFiltrada=this.ListPropuestas.filter((value) => {
				if (this.ListPropuestasOcupadas.includes(value.IdPropuesta) && value.IdPropuesta!=this.ProyectoAdicion.IdPropuesta) {
					return false;
				}
				else{
					return true;
				}
			});
			this.ListPropuestas=ListaFiltrada;
		},
		SeleccionPropuesta(){
			let Index=this.ListPropuestas.findIndex((value)=>value.IdPropuesta==this.ProyectoAdicion.IdPropuesta);
			if (Index!=-1) {
				let formatedDate=this.ListPropuestas[Index].FechaVenta.replace(/-/g, "\/");
				this.ProyectoAdicion.FechaVenta=new Date(formatedDate);
				let formatedDate2 = this.ListPropuestas[Index].FechaTermino.replace(/-/g, "\/");
				this.ProyectoAdicion.FechaTermino=new Date(formatedDate2);
				this.ProyectoAdicion.TipoContrato=this.ListPropuestas[Index].TipoContrato;
				this.ProyectoAdicion.ValorVenta=this.ListPropuestas[Index].ValorVenta;
				this.ProyectoAdicion.IdTipoSer=this.ListPropuestas[Index].TipoServicio;
				this.ProyectoAdicion.IdVenta=this.ListPropuestas[Index].IdVenta;
				this.ProyectoAdicion.Vendedor=this.ListPropuestas[Index].Usuario;
				switch (this.ListPropuestas[Index].Tipo) {
					case '1':
						this.ProyectoAdicion.IdConfigS='Mantenimiento';		
						break;
					case '2':
						this.ProyectoAdicion.IdConfigS='Servicio';		
						break;
					case '3':
						this.ProyectoAdicion.IdConfigS='Proyecto';
						break;
				}
				switch (this.ListPropuestas[Index].NumPagos) {
					case '1':
						this.ProyectoAdicion.CantidadPago='1 Pago';
						break;
					case '2':
						this.ProyectoAdicion.CantidadPago='2 Pagos';
						break;
					case '3':
						this.ProyectoAdicion.CantidadPago='3 Pagos';
						break;
					case '4':
						this.ProyectoAdicion.CantidadPago='4 Pagos';
						break;
					case '5':
						this.ProyectoAdicion.CantidadPago='Estimados';
						break;
					case '6':
						this.ProyectoAdicion.CantidadPago='Mensual';
						break;
					case '7':
						this.ProyectoAdicion.CantidadPago='Bimestral';
						break;
					case '8':
						this.ProyectoAdicion.CantidadPago='Trimestral';
						break;
					default:
						break;
				}
			}
		},
		SeleccionContrato(){
			let Index=this.ListContratos.findIndex((value) => value.IdContrato==this.ProyectoAdicion.IdContrato);
			// console.log(Index);
			if (Index!=-1) {
				let formatedDate = this.ListContratos[Index].FechaVenta.replace(/-/g, "\/");
				this.ProyectoAdicion.FechaVenta=new Date(formatedDate);
				let formatedDate2 = this.ListContratos[Index].FechaTermino.replace(/-/g, "\/");
				this.ProyectoAdicion.FechaTermino=new Date(formatedDate2);
				this.ProyectoAdicion.TipoContrato=this.ListContratos[Index].TipoContrato;
				this.ProyectoAdicion.ValorVenta=this.ListContratos[Index].ValorVenta;
				this.ProyectoAdicion.IdTipoSer=this.ListContratos[Index].TipoServicio;
				this.ProyectoAdicion.Propuesta=this.ListContratos[Index].Propuesta;
				this.ProyectoAdicion.IdVenta=this.ListContratos[Index].IdVenta;
				this.ProyectoAdicion.IdPropuesta=this.ListContratos[Index].IdPropuesta;
				this.ProyectoAdicion.Vendedor=this.ListContratos[Index].Usuario;
				switch (this.ListContratos[Index].IdConfigS) {
					case '1':
						this.ProyectoAdicion.IdConfigS='Mantenimiento';		
						break;
					case '2':
						this.ProyectoAdicion.IdConfigS='Servicio';		
						break;
					case '3':
						this.ProyectoAdicion.IdConfigS='Proyecto';
						break;
				}
				switch (this.ListContratos[Index].NumPagos) {
					case '1':
						this.ProyectoAdicion.CantidadPago='1 Pago';
						break;
					case '2':
						this.ProyectoAdicion.CantidadPago='2 Pagos';
						break;
					case '3':
						this.ProyectoAdicion.CantidadPago='3 Pagos';
						break;
					case '4':
						this.ProyectoAdicion.CantidadPago='4 Pagos';
						break;
					case '5':
						this.ProyectoAdicion.CantidadPago='Estimados';
						break;
					case '6':
						this.ProyectoAdicion.CantidadPago='Mensual';
						break;
					case '7':
						this.ProyectoAdicion.CantidadPago='Bimestral';
						break;
					case '8':
						this.ProyectoAdicion.CantidadPago='Trimestral';
						break;
					default:
						break;
				}
			}
		}
		// SubirArchivo1(){
		// 	const image = this.$refs.archivouno.files[0];

        //     var FileSize = image.size / 1024 / 1024; // in MB
        //     if (FileSize > 0.5) {
        //         this.$toast.info('Solo se puede subir archivos menores a 0.5 MB');
        //         const  input  = this.$refs.archivouno;
        //         input .type = 'text'
        //         input .type = 'file';
        //         return false;
        //     }
                        
        //     var allowedExtensions = /(\.pdf|\.PDF)$/i;
        //     if(!allowedExtensions.exec(image.name)){
        //         this.$toast.info('Extenciones permitidas .pdf');
        //         const  input  = this.$refs.archivouno;
        //         input.type = 'text'
        //         input.type = 'file';
        //         this.ArchivoUno='Elegir archivo (0.5MB)';
        //         return false;
        //     }

        //     this.ArchivoUno=image.name;
		// },
		// SubirArchivo2(){
		// 	const image = this.$refs.archivodos.files[0];

        //     var FileSize = image.size / 1024 / 1024; // in MB
        //     if (FileSize > 0.5) {
        //         this.$toast.info('Solo se puede subir archivos menores a 0.5 MB');
        //         const  input  = this.$refs.archivodos;
        //         input .type = 'text'
        //         input .type = 'file';
        //         return false;
        //     }
                        
        //     var allowedExtensions = /(\.pdf|\.PDF)$/i;
        //     if(!allowedExtensions.exec(image.name)){
        //         this.$toast.info('Extenciones permitidas .pdf');
        //         const  input  = this.$refs.archivodos;
        //         input.type = 'text'
        //         input.type = 'file';
        //         this.ArchivoDos='Elegir archivo (0.5MB)';
        //         return false;
        //     }

        //     this.ArchivoDos=image.name;
		// }
	},
	created() {
		this.bus.$off("NewModal_"+this.EmitSeccion);
        this.bus.$on("NewModal_"+this.EmitSeccion,(data,Id,IdProyecto)=>{
            this.poBtnSave.disableBtn=false;
            this.bus.$off("Save_"+this.EmitSeccion);
            this.bus.$on("Save_"+this.EmitSeccion, () => {
				this.Guardar();
			});
            this.Limpiar();
            if (IdProyecto!==undefined) {
                this.ProyectoAdicion.IdProyecto=IdProyecto;
            }
            if (Id > 0) {
				this.ProyectoAdicion.IdProyectoAdicion = Id;
				this.Recuperar();
			}
			else{
				// this.GetContratos();
				this.GetPropuestas();
			}
        });
	},
	computed:{
        typeCalendar:function(){
            return 'single';
        }
    }
}
</script>

<style>

</style>
